// sync selectors

import { createSelector } from '@ngrx/store';
import * as downloadReducer from '../reducers/download.reducer';
import { getDownloadedMedia } from '../../persistent/media/media.selectors';
import { getDownloadState } from '../../../../app/store';
import { getProgramModules } from '../../normalized/selectors/program-bootstrap.selectors';
import { getNormalizedMediaFiles, getMediaFilesByModule } from '../../normalized/selectors/mediafiles.selectors';
import {
  getAvailableBonusExercisesIds,
  getMediaFilesByBonusExercise
} from '../../../../app/store/normalized/selectors/exercises.selectors';

export const getDownloadQueue = createSelector(
  getDownloadState,
  downloadReducer.downloadQueue
);

export const getCurrentDownloadMediaFile = createSelector(
  getDownloadState,
  downloadReducer.currentMediaFile
);

export const getQueuedMediaFiles = createSelector(
  getDownloadQueue,
  getNormalizedMediaFiles,
  (queue, normalizedMediaFiles) => queue.map((id) => normalizedMediaFiles[id])
);

export const isDownloading = createSelector(
  getDownloadState,
  downloadReducer.downloading
);

export const getOfflineStorageStatus = createSelector(
  getDownloadState,
  downloadReducer.offlineStorageStatus
);

export const getDownloadedModules = createSelector(
  getDownloadedMedia,
  getProgramModules,
  getMediaFilesByModule,
  getAvailableBonusExercisesIds,
  getMediaFilesByBonusExercise,
  ((downloadedMedia, modules, mediaByModule, bonusExercisesIds, mediaByExercise) => {
    const downloadedModules = [];
    if (!modules || !modules.length) {
      return downloadedModules;
    }

    // console.log(downloadedMedia, modules, mediaByModule);

    // add modules
    for (let i = 0; i < modules.length; i++) {
      if (arrayContainsArray(downloadedMedia, mediaByModule[modules[i].number])) {
        downloadedModules.push(modules[i].number);
      }
    }
    // add bonus exercises
    for (let i = 0; i < bonusExercisesIds.length; i++) {
      if (arrayContainsArray(downloadedMedia, mediaByExercise[bonusExercisesIds[i]])) {
        downloadedModules.push('e' + bonusExercisesIds[i]);
      }
    }

    return downloadedModules;
  })
);

function arrayContainsArray(superset, subset) {
  return subset && subset.length && subset.every((value) => (superset.indexOf(value) >= 0));
}
